import type { ComponentSize } from "./common.constants";

export const INPUT_SIZE_STYLE: Record<
  ComponentSize,
  {
    input: string;
    icon: string;
    label: string;
  }
> = {
  xs: {
    input: "h-7 px-2 text-xs",
    icon: "text-xs",
    label: "text-xs",
  },
  sm: {
    input: "h-8 px-2 text-sm",
    icon: "text-sm",
    label: "text-xs",
  },
  md: {
    input: "h-10 px-3 text-sm",
    icon: "text-base",
    label: "text-sm",
  },
  lg: {
    input: "h-12 px-4 text-base",
    icon: "text-lg",
    label: "text-base",
  },
};
